module.exports = __webpack_public_path__ + "resources/img/bg_banner_support_m.8eacf37e64c66b16131614b12bcad077.png";